// extracted by mini-css-extract-plugin
export default {"statementContainer":"Statement_statementContainer__OIgM4"};